import { assignIn, get as lodashGet } from 'lodash';

import { TreeArray } from '../../../common/tree-array/tree-array';

interface FormularAssignments {
  [key: string]: any;
}

export class FormularBuilder {
  private formular: string;

  /**
   * buildFormular
   */
  public buildFormular(formulaItems, auditNodes): { formular: string; assignments: FormularAssignments } {
    this.formular = formulaItems[0].value;

    if (formulaItems.length > 1 && formulaItems[1].value) {
      const formulaLinkedNodeIds: string[] = formulaItems[1].value;
      const result = this.createAssignments(this.formular, {}, formulaLinkedNodeIds, auditNodes);
      return result;
    }
    return { formular: this.formular, assignments: {} };
  }

  private createAssignments(formular: string, assignments: {}, linkedNodes, allNodes): any {
    let fnFormular = formular;
    let fnAssignments = { ...assignments };
    for (let index = 0; index < linkedNodes.length; index++) {
      const linkedNode = linkedNodes[index];
      const node = this.findNodeById(allNodes, linkedNode._id);
      if (!node) {
        return assignments;
      }
      if (node.nodeType_Id === 'formula') {
        const formulaLinkNodes = node.selectables[1].value;
        const reg = new RegExp(`\\[${node.templateNodeId}\\]`, 'g');
        fnFormular = fnFormular.replace(reg, `(${node.selectables[0].value})`);
        const result = this.createAssignments(fnFormular, fnAssignments, formulaLinkNodes, allNodes);
        fnFormular = result.formular;
        fnAssignments = result.assignments;
      } else {
        fnAssignments[node.templateNodeId] = this.prepareVal(node, linkedNode);
      }
    }
    return { formular: fnFormular, assignments: fnAssignments };
  }

  private prepareVal(node, linkedNode) {
    let value;
    value = lodashGet(node, linkedNode.path);
    if (Array.isArray(value)) {
      value = this.parseArrayValues(node, value);
    } else {
      value = this.parseSingleValue(node, value);
    }
    if (this.isNumber(value)) {
      value = parseFloat(value);
    }
    return value;
  }

  private findNodeById(auditNodes, id) {
    const treeArray = assignIn(new TreeArray(), auditNodes);
    return treeArray.findRec(n => n.templateNodeId === id);
  }

  private isNumber(value: any): boolean {
    return value !== undefined && !isNaN(parseFloat(value)) && !isNaN(value - 0);
  }

  private parseArrayValues(node, value) {
    if (this.isMultiple(node)) {
      const sel = value.filter(f => f.selected);
      return sel.map(m => (this.isNumber(m.value) ? parseFloat(m.value) : 0)).reduce((acc, val) => acc + val, 0);
    }
    const selected = value.find(f => f.selected);
    if (selected) {
      return this.isNumber(selected.value) ? parseFloat(selected.value) : selected.value;
    }
  }

  private parseSingleValue(node, value) {
    if (value !== undefined) {
      if (node.nodeType_Id === 'date') {
        return new Date(value).getTime();
      } else if (node.nodeType_Id === 'number') {
        return parseFloat(value);
      }
      return value;
    }
  }

  private isMultiple(node: any): boolean {
    return node.options && node.options.allowMultiple;
  }
}
